// extracted by mini-css-extract-plugin
export default {"hidden":"WiNDrN","link":"onyaFj","active":"pbczMb","svg":"Rq4mPF","prev":"a3lVhu","link-active":"t6NbiN","linkActive":"t6NbiN"};